export const utilGetLinkRel = (
  href?: string,
  isTarget?: boolean
): string | undefined => {
  if (!href) {
    return undefined;
  }

  let isExternal = false;

  if (typeof window !== 'undefined') {
    try {
      const url = new URL(href, window.location.origin);

      isExternal = url.origin !== window.location.origin;
    } catch {
      // некорректный href, считаем как внешнюю ссылку
      isExternal = /^https?:\/\//.test(href);
    }
  } else {
    // SSR fallback
    isExternal = /^https?:\/\//.test(href);
  }

  const rel = isTarget
    ? isExternal
      ? 'nofollow noopener noreferrer'
      : 'noopener noreferrer'
    : isExternal
      ? 'nofollow'
      : undefined;

  return rel;
};
